let isNextEnv = true;

// Check if NextJs process object should be used
if (import.meta.env) {
  isNextEnv = false;
}

const envs = isNextEnv ? process.env : import.meta.env;

export const POSTS_URL = `${envs.VITE_API_DOMAIN}/api/posts`;
export const POST_URL = `${envs.VITE_API_DOMAIN}/api/post`;
